import React from 'react';

const DashedLineIcon: React.FC = () => (
  <svg width="459" height="1" viewBox="0 0 459 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="0.5" x2="459" y2="0.5" stroke="#D2D6DB" strokeDasharray="5 5" />
  </svg>
);

export default DashedLineIcon;
